export enum TransactionStatus {
  AwaitingApproval = 50,
  Pending = 100,
  Completed = 200,
  Cancelled = 300,
  Declined = 400,
  Failed = 500,
  Reversed = 600,
}

export const isTransactionPendingStatus = (status: TransactionStatus): boolean => {
  return status === TransactionStatus.Pending
}

export const isTransactionCompletedStatus = (status: TransactionStatus): boolean => {
  return status === TransactionStatus.Completed
}

export const isTransactionDeclinedStatus = (status: TransactionStatus): boolean => {
  return status === TransactionStatus.Declined
}

export const isTransactionFailedStatus = (status: TransactionStatus): boolean => {
  return status === TransactionStatus.Failed
}

export const isTransactionReversedStatus = (status: TransactionStatus): boolean => {
  return status === TransactionStatus.Reversed
}

export enum TransactionPaymentProviderDifferentCurrencyField {
  PAYMENT_PROVIDER_CURRENCY_ID = 'payment_currency_id',
}
// /transactions/complete
// /transactions/cancel
// /transactions/decline
// /transactions/fail
// /transactions/reverse

export const getUriToUpdateFromStatusId = (statusId: TransactionStatus): string | null => {
  switch (statusId) {
    case TransactionStatus.AwaitingApproval:
      return null
    case TransactionStatus.Pending:
      return 'set-pending'
    case TransactionStatus.Completed:
      return 'complete'
    case TransactionStatus.Cancelled:
      return 'cancel'
    case TransactionStatus.Declined:
      return 'decline'
    case TransactionStatus.Failed:
      return 'fail'
    case TransactionStatus.Reversed:
      return 'reverse'
    default:
      return null
  }
}

export const isNotAllowedToChangeState = (stateId: number): boolean => {
  // completed/declined/failed/Reversed
  const nowAllowedIds = [
    TransactionStatus.Completed,
    TransactionStatus.Declined,
    TransactionStatus.Reversed,
  ] // Completed, Declined, Reversed
  return nowAllowedIds.includes(stateId)
}
